import { render, staticRenderFns } from "./ArticleRow.vue?vue&type=template&id=795701d5&scoped=true"
import script from "./ArticleRow.vue?vue&type=script&lang=js"
export * from "./ArticleRow.vue?vue&type=script&lang=js"
import style0 from "./ArticleRow.vue?vue&type=style&index=0&id=795701d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795701d5",
  null
  
)

export default component.exports